module.exports = __webpack_public_path__ + "static/media/soils_reports_1.a17dcbd4.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_reports_1.png
// module id = 1288
// module chunks = 0